import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
// 用Vuex.Store对象用来记录token
const store = new Vuex.Store({

  state: {
    // 存储token
    token: "",
    userName: "" // 可选
  },
  getters: {
    getToken(state) {
      return state.token || localStorage.getItem("token") || "";
    }
  },
  mutations: {
    // 修改token，并将token存入localStorage
    setToken(state, token) {
      state.token = token;
      localStorage.setItem('token', token);
      console.log('store、localstorage保存token成功！');
    },
    setUserName(state, userName) {
      state.userName = userName;
      localStorage.setItem('userName', userName);
      console.log('store、localstorage保存userName成功！');
    },
    delToken(state) {
      state.token = "";
      localStorage.removeItem("token");
    },
    setUserID(state, id) {
      state.id = id;
      localStorage.setItem('id', id);
      console.log('store、localstorage保存用户id成功！');
    },
    delID(state) {
      state.id = "";
      localStorage.removeItem("id");
    },
    delUserName(state) {
      state.userName = "";
      localStorage.removeItem("userName");
    },
    // 可选
    setUserInfo(state, userName) {
      state.userName = userName;
    }
  },

  actions: {
    // removeToken: (context) => {
    // context.commit('setToken')
    // }
  },
});

export default store;